import { render, staticRenderFns } from "./Tagesabschluss.vue?vue&type=template&id=19edbbc8&"
import script from "./Tagesabschluss.vue?vue&type=script&lang=ts&"
export * from "./Tagesabschluss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports